SidebarState = require 'view-models/sidebar-state'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
trackUe = require 'debug/trackUe'
{ Noun, Verb } = require 'common/debug/analytics-constants'

module.exports = class HeaderBoardsButtonView extends View

  className: 'header-boards-button'

  events:
    'click .js-boards-menu': 'toggleBoardsSidebar'

  render: ->

    @$el.html(
      templates.fill(
        'header_boards_menu_button'
      )
    )

    @

  toggleBoardsSidebar: (e) ->
    Util.stop(e)

    if SidebarState.getShowSidebar()
      trackUe(Noun.HEADER, Verb.CLOSES, Noun.BOARDS_MENU, '', '', 'by clicking boards button in header')
      SidebarState.hideSidebar()
    else
      trackUe(Noun.HEADER, Verb.OPENS, Noun.BOARDS_MENU, '', '', 'by clicking boards button in header')
      SidebarState.showSidebar()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-boards-button-view.coffee